import useLadyService from '@/services/LadyService';
import Popup from '../Popup';
import { useDispatch } from 'react-redux';
import { setShowTariffsGuestPopup } from '@/stores/slices/popupSlice';

const TarrifsListPopup = () => {
	const { t, capitalizeFirstLetter } = useLadyService();
	const dispatch = useDispatch();

	return (
		<Popup
			open={true}
			setOpen={() => {
				dispatch(setShowTariffsGuestPopup(false));
			}}
			clazz={'gap-8 tariffs-guest-popup'}
			container={'div'}
		>
			<h2 className="mb-16">
				{t('tariffs')} {t('and')} {t('discounts').toLowerCase()}
			</h2>
			<table>
				<thead className="up-table__header">
					<th>{t('myads')}</th>
					<th>{`${t('price')} ${t('per')} ${t('month')}`}</th>
					<th>{capitalizeFirstLetter(t('discount'))}</th>
				</thead>
				<tbody>
					<tr className={'up-table__row'}>
						<td>{1}</td>
						<td>40 € / 990 Kč</td>
						<td>&mdash;</td>
					</tr>

					<tr className={'up-table__row'}>
						<td>{2}</td>
						<td>38 € / 940 Kč</td>
						<td>5%</td>
					</tr>

					<tr className={'up-table__row'}>
						<td>{3}</td>
						<td>36 € / 890 Kč</td>
						<td>10%</td>
					</tr>

					<tr className="up-table__row up-table__row empty">
						<td>&mdash;</td>
						<td>&mdash;</td>
						<td>&mdash;</td>
					</tr>

					<tr className="up-table__row up-table__row__zero__last">
						<td>{11}+</td>
						<td>20 € / 490 Kč</td>
						<td>50%</td>
					</tr>
				</tbody>
			</table>

			<p className="p2 text-center m-0">
				{t('moreads')}
				<br />
				{t('lowprice')}
			</p>
		</Popup>
	);
};

export default TarrifsListPopup;
